var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"property_detail_summary",domProps:{"innerHTML":_vm._s(_vm.propertySummary)}})
}
var staticRenderFns = []

export { render, staticRenderFns }